import { render, staticRenderFns } from "./GradeSelector.vue?vue&type=template&id=ac78a484&scoped=true&"
import script from "./GradeSelector.vue?vue&type=script&lang=ts&"
export * from "./GradeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./GradeSelector.vue?vue&type=style&index=0&id=ac78a484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac78a484",
  null
  
)

export default component.exports